<template>
    <v-app v-if="authenticated" id="app" :dark="false">
        <router-view/>
    </v-app>
    <v-app v-else>
        <v-dialog :value="true" persistent>
            <v-card color="primary darken-1" dark>
                <v-card-text>
                    <div>{{ authText }}</div>
                    <v-progress-linear indeterminate color="white" v-if="isChecking" />
                    <div>
                        <v-btn dark
                               v-if="!isChecking"
                               text
                               @click="loginRedirect"
                               large
                               elevation="3"
                               block
                               class="loginButton">
                            Login
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
    import axios from "./utils/axiosInstance";
    import { notificationMixin } from "./mixins/notificationMixin.js";
    import eventBus from "./utils/eventBus";

    const _ = require("lodash");

    export default {
        name: "app",
        mixins: [notificationMixin],
        data: () => ({
            authText: "Checking authentication...",
            isChecking: true,
            authenticated: false,
            needUpdate: false,
            tableScrollPosition: null
        }),
        created: async function () {
            await this.checkAuthentification();
            eventBus.$on("fullUpdate", args => this.update(args));
        },
        methods: {
            async loginRedirect() {
                /*
                if (
                    process.env.VUE_APP_SET_DEFAULT_COOKIE_IN_DEV &&
                    process.env.NODE_ENV === "development" &&
                    process.env.VUE_APP_EXAMPLE_TOKEN
                ) {
                    document.cookie = `authToken=${process.env.VUE_APP_EXAMPLE_TOKEN}`;
                } else if (
                    process.env.VUE_APP_SET_ENV_COOKIE &&
                    process.env.VUE_APP_ENV_TOKEN
                ) {
                    document.cookie = `authToken=${process.env.VUE_APP_ENV_TOKEN}`;
                } else {
                    window.location.href = "https://mymuenet.swiss/#/login"
                }
                */
                window.location.href = "/login";
                await this.checkAuthentification();
            },
            async checkAuthentification() {
                this.isChecking = true;
                this.authText = "Checking authentication...";
                try {
                    const result = await axios.get("/checkAuth");
                    if (result.status === 200) {
                        this.authenticated = true;
                        this.successNotification("Authentification successful.");
                        return;
                    }
                } catch (err) {
                    // can be ignored silently
                }
                this.authenticated = false;
                this.isChecking = false;
                this.authText = "You are not authenticated. Please log in from myMuenet";
                return false;
            },
            update(args) {
                this.needUpdate = true;
                this.$nextTick(() => (this.needUpdate = false));
            },
        }
    };
</script>

<style>
    #app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    #image {
        height: 100%;
        width: 100%;
    }

    html,
    body {
        height: 100%; /* needed for proper layout */
        overflow-y: hidden !important;
    }

    .loginButton {
        margin-top: 15px;
    }

    .banner {
        margin: 10px;
    }

    .titlebar {
        flex: 0 0 auto;
    }

    .footer {
        flex: 0 0 auto;
    }

    .editor {
        flex: 1 1 auto;
        position: relative; /* need this to position inner content */
        overflow-y: auto;
    }

    .unmarkable {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s !important;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>
